import './assets/zoezi.css'
import './assets/zoezi-unmerged-adjustments.css'
import Vue from 'vue'
import App from './App.vue'
import {getVuetify} from './plugins/vuetify';

import components from './component.js'
import {initRouter} from './router.js'

import {initStore} from './store/store.js'
import ZoeziApi from './services/ZoeziApi.js'
import './dateextensions.js'
import Translate from './services/Translate.js'
import Booking from './services/Booking.js';
import '@mdi/font/css/materialdesignicons.css'
import colors from 'vuetify/lib/util/colors'
import {classToHex} from 'vuetify/lib/util/colorUtils'
import {camelize} from 'vuetify/lib/util/helpers'
import './stringextensions.js'
import './numberextensions.js'
import 'animate.css/animate.min.css';
import ZoeziEditable from './plugins/ZoeziEditableWithDelayedSave.js'
import SafeHtml from './plugins/safeHtml.js'
import VStripeElements from 'v-stripe-elements/lib/index.js'
import LoadScript from 'vue-plugin-load-script'
import PortalVue from 'portal-vue'
import VueMeta from 'vue-meta'
import {addOrUpdateStyle, formatPrice, getRandomId, setRootProps, getUrlParameterThis, isString, applyTemplateSettings, initExpo, getCookie, setCookie, isCookieConsentEnabled} from './util.js'
import EcommerceTracking from './services/EcommerceTracking.js'

import setProp from './services/SetProp.js'

let IS_LOCALHOST = location.hostname.endsWith('zoezidev.se');

let HOSTNAME = window.location.protocol + '//' + window.location.hostname;

Vue.config.productionTip = false

function initVue(homepages, homepage, edit=false) {
    if (homepage && homepage.config && window.ZOEZI_SETTINGS) {
        applyTemplateSettings(homepage.config, window.ZOEZI_SETTINGS)
    }
    
    let isInIframe = function() {
        try {
            return window.self !== window.top;
        } catch (e) {
            return true;
        }
    };
    
    /*if (isInIframe()) {
    edit = true;
    }*/
    
    Vue.use(Translate);
    Vue.use(ZoeziApi);
    Vue.use(Booking);
    Vue.use(ZoeziEditable);
    Vue.use(SafeHtml);
    Vue.use(VStripeElements);
    Vue.use(LoadScript);
    Vue.use(PortalVue);
    Vue.use(EcommerceTracking);
    Vue.use(VueMeta, {
        refreshOnceOnNavigation: true,
    })
    
    const homepage_type = homepage.type || 'mb';
    const emptyConfig = {
        mb: {
            name: 'Tom hemsida',
            title: 'Zoezi',
            topbar: {
                color: 'black',
                backgroundColor: 'white',
                activeColor: 'red',
                justify: 'justify-end'
            },
            menu: {
                right: true
            },
            buttons: [],
            routes: []
        },
        sf: {
            routes: [],
            pages: {}
        }
    }
    let config = homepage.config || emptyConfig[homepage_type];
    const MB = homepage_type == 'mb';
    
    if (MB) {
        // FIXME: Make sure required stuff is in config
        if (!config.routes) {
            config.routes = [];
        }
        
        if (!config.topbar) {
            config.topbar = {
                color: '#000',
                backgroundColor: '#fff',
                activeColor: '#f00',
                justify: 'justify-end'
            };
        }
        if (!config.menu) {
            config.menu = {
                right: true
            };
        }
        
        config.routes.forEach(route => {
            if (route.component != 'zoezi-page' && route.config) {
                Object.assign(route, {component: 'zoezi-page', props: {name: route.name, path: route.path, config: route.config}});
                delete route.config;
                delete route.path;
                delete route.name;
            } else if (route.component != 'zoezi-page' && route.props) {
                Object.assign(route, {component: 'zoezi-page', props: {name: route.name, path: route.path, config: {component: route.component, props: route.props, style: route.style, id: route.id}}});
                delete route.config;
                delete route.path;
                delete route.name;
                delete route.style;
                route.id = components.makeEmptyConfig().id;
            } else if (route.component != 'zoezi-page' && !route.props) {
                let name = route.path;
                let path = route.path;
                let component = route.component || 'zoezi-rowlayout';
                let rows = route.rows;
                route.id = route.id || components.makeEmptyConfig().id;
                Object.assign(route, {component: 'zoezi-page', props: {name, path, config: {component: component, props: {rows: rows}, style: route.style, id: route.id}}});
                delete route.path;
                delete route.name;
                delete route.style;
                route.id = components.makeEmptyConfig().id;
            } else if (route.component == 'zoezi-page' && route.props && (!route.props.path || !route.props.name)) {
                let i = getRandomId(10);
                if(!route.props.path) route.props.path = '/' + i;
                if(!route.props.name) route.props.name = 'nameless-' + i;
            }
        })
    } else if (homepage_type == 'sf') {
        if (!config.routes) {
            config.routes = [];
        }
        if (!config.pages) {
            config.pages = {};
        }
        if (!config.root) {
            config.root = components.makeEmptyConfig({component: 'zoezi-root', props: {
            }});
        }
        
        if (!config.root.props.appComponent) {
            config.root.props.appComponent = components.makeEmptyConfig();
        }
        
    }
    
    // We always need a root page
    if (!config.routes.find(route => route.props.path == '/')) {
        config.routes.push(components.makeEmptyConfig({component: 'zoezi-page', props: {name: '/', path: '/', config: components.makeEmptyConfig({component: 'zoezi-rowlayout'})}}));
    }
    
    if (MB) {
        // We always need a login page
        if (!config.routes.find(route => route.props.path == '/login')) {
            config.routes.push(components.makeEmptyConfig({component: 'zoezi-page', props: {name: '/login', path: '/login', config: components.makeEmptyConfig({component: 'zoezi-rowlayout', props: {rows: [components.makeEmptyConfig({component: 'zoezi-row', props: {columns: [components.makeEmptyConfig({component: 'zoezi-column', props: {cols: 12, component: components.makeEmptyConfig({component: 'zoezi-login'})}})]}})]}})}}));
        }
        
        // We always need a terms page
        if (!config.routes.find(route => route.props.path == '/terms')) {
            config.routes.push(components.makeEmptyConfig({component: 'zoezi-page', props: {name: '/terms', path: '/terms', config: components.makeEmptyConfig({component: 'zoezi-rowlayout', props: {rows: [components.makeEmptyConfig({component: 'zoezi-row', props: {columns: [components.makeEmptyConfig({component: 'zoezi-column', props: {cols: 12, component: components.makeEmptyConfig({component: 'zoezi-terms'})}})]}})]}})}}));
        }
        
        // We always need a policy page
        if (!config.routes.find(route => route.props.path == '/policy')) {
            config.routes.push(components.makeEmptyConfig({component: 'zoezi-page', props: {name: '/policy', path: '/policy', config: components.makeEmptyConfig({component: 'zoezi-rowlayout', props: {rows: []}})}}));
        }
        
        // We always need a reset password page
        if (!config.routes.find(route => route.props.path == '/resetpassword')) {
            config.routes.push(components.makeEmptyConfig({component: 'zoezi-page', props: {name: '/resetpassword', path: '/resetpassword', config: components.makeEmptyConfig({component: 'zoezi-rowlayout', props: {rows: [components.makeEmptyConfig({component: 'zoezi-row', props: {columns: [components.makeEmptyConfig({component: 'zoezi-column', props: {cols: 12, component: components.makeEmptyConfig({component: 'zoezi-reset-password'})}})]}})]}})}}));
        }
        
        // We always need a unsubscribe page
        if (!config.routes.find(route => route.props.path == '/unsubscribe')) {
            config.routes.push(components.makeEmptyConfig({component: 'zoezi-page', props: {name: '/unsubscribe', path: '/unsubscribe', config: components.makeEmptyConfig({component: 'zoezi-rowlayout', props: {rows: [components.makeEmptyConfig({component: 'zoezi-row', props: {columns: [components.makeEmptyConfig({component: 'zoezi-column', props: {cols: 12, component: components.makeEmptyConfig({component: 'zoezi-unsubscribe'})}})]}})]}})}}));
        }
        
        // We always need a mailing unsubscribe page
        if (!config.routes.find(route => route.props.path == '/mailingunsubscribe')) {
            config.routes.push(components.makeEmptyConfig({component: 'zoezi-page', props: {name: '/mailingunsubscribe', path: '/mailingunsubscribe', config: components.makeEmptyConfig({component: 'zoezi-rowlayout', props: {rows: [components.makeEmptyConfig({component: 'zoezi-row', props: {columns: [components.makeEmptyConfig({component: 'zoezi-column', props: {cols: 12, component: components.makeEmptyConfig({component: 'zoezi-mailing-unsubscribe'})}})]}})]}})}}));
        }
        
        if (!config.pages || Array.isArray(config.pages)) {
            config.pages = {}
        }
        
        if (!config.topbar.loginColor) {
            config.topbar.loginColor = '#fff';
        }
        
        if (!config.topbar.loginBackgroundColor) {
            config.topbar.loginBackgroundColor = '#1976D2';
        }
        
        if (!config.buttons) {
            config.buttons = [];
        }
        
        if (config.buttons.length && !config.buttons[0].props) {
            config.buttons = [];
        }
        
        config.buttons.forEach(b => {
            if (!b.props.subitems) {
                b.props.subitems = [];
            }
        })
        
        if (!config.footer || !config.footer.component) {
            config.footer = components.makeEmptyConfig();
        }
        
        if (!config.cookieBar) {
            config.cookieBar = components.makeEmptyConfig({component: 'zoezi-cookie-bar'});
        }
        
        config.hostname = window.location.hostname;
        
        if (!config.appbar) {
            let props = Object.assign({}, config.topbar);
            props.logo = config.logo;
            props.uppercase = config.menu.uppercase;
            props.fullWidth = config.menu.fullWidth;
            props.rightComponent = components.makeEmptyConfig({component: 'zoezi-account-button'});
            config.appbar = components.makeEmptyConfig({component: 'zoezi-appbar', props});
        }
        
        if (!config.bottombar) {
            config.bottombar = components.makeEmptyConfig({component: 'zoezi-bottombar'});
        }
        
        if (!config.fonts) {
            config.fonts = {};
        }
        
        if (!config.ownComponents) {
            config.ownComponents = {};
        }
        
        if (!config.root) {
            config.root = components.makeEmptyConfig({component: 'zoezi-root', props: {
                name: config.name,
                title: config.title,
                favicon: config.favicon,
                showFooter: config.showFooter,
                font: config.font
            }});
        }
        
        if (config.footer && config.footer.visible !== undefined) {
            config.root.props.showFooter = config.footer.visible;
            delete config.footer.visible;
        }
        
        let renameComponents = function(o) {
            if (typeof o !== 'object' || !o) {
                return;
            }
            
            if (o.component && typeof(o.component) === 'string') {
                const map = {
                    Html: 'zoezi-html',
                    RowLayout: 'zoezi-rowlayout',
                    Home: 'zoezi-home',
                    GroupTraining: 'zoezi-grouptraining',
                    Carousel: 'zoezi-carousel',
                    'zoezi-personallista': 'zoezi-stafflist',
                    MenuItem: 'zoezi-menuitem',
                    TextAndTitle: 'zoezi-text'
                };
                if (map[o.component]) {
                    o.component = map[o.component];
                    console.log('Renaming component')
                }
                
                if (!o.id) {
                    o.id = components.makeEmptyConfig().id;
                }
                
                if (o.component == 'zoezi-page' && !o.props.name) {
                    o.props.name = o.props.path;
                }
            }
            
            let arr = Array.isArray(o) ? o : Object.values(o);
            arr.forEach(x => {
                renameComponents(x);
            })
        };
        
        renameComponents(config);
        
        let fixRowLayouts = function(o) {
            if (typeof o !== 'object' || !o) {
                return;
            }
            
            if (o.component == 'zoezi-rowlayout') {
                let newrows;
                
                if (!o.props.rows) {
                    o.props.rows = [];
                }
                
                o.props.rows.forEach(row => {
                    if (Array.isArray(row)) {
                        if (!newrows) {
                            newrows = [];
                        }
                        let newrow = {component: 'zoezi-row', props: {columns: []}}
                        newrow.props.columns = row.map(columnConfig => {
                            let col = Object.assign({}, columnConfig);
                            delete col.width;
                            let config = {component: 'zoezi-column', props: {cols: columnConfig.width, component: components.makeEmptyConfig(col)}};
                            return config;
                        })
                        newrows.push(newrow);
                    }
                });
                
                if (newrows) {
                    o.props.rows = newrows;
                }
            }
            
            let arr = Array.isArray(o) ? o : Object.values(o);
            arr.forEach(x => {
                fixRowLayouts(x);
            })
        };
        
        fixRowLayouts(config);
        
        let migrateProps = function(o) {
            if (typeof o !== 'object' || !o) {
                return;
            }
            
            if (o.component && typeof(o.component) === 'string') {
                let c = components.getComponent(o.component);
                if (c && c.migrations) {
                    c.migrations.forEach(mig => mig(o.props))
                }
                
                // FIXME: Caused by a bug at one point. Can be removed soon
                if (c && o.props) {
                    Object.keys(o.props).forEach(key => {
                        if (key.startsWith('<')) {
                            delete o.props[key];
                        }
                    })
                }
            }
            
            let arr = Array.isArray(o) ? o : Object.values(o);
            arr.forEach(x => {
                migrateProps(x);
            })
        };
        
        migrateProps(config);
    }
    
    window.initExpo = initExpo;
    
    if (MB) {
        if (!config.root.props.cookieBar) {
            config.root.props.cookieBar = config.cookieBar;
        }
        if (!config.root.props.colors && config.colors) {
            config.root.props.colors = config.colors;
        }
        delete config.colors;
        
        if (isString(config.root.props.cookieBar)) {
            config.root.props.cookieBar = components.makeEmptyConfig({component: 'zoezi-cookie-bar'});
        }

        // Customer sites must always ask. Shared pages (templates and Zoezi's internal pages) are configured by Zoezi.
        if (isCookieConsentEnabled() && !homepage.shared && config.root.props.cookieBar.component !== 'zoezi-cookie-bar') {
            config.root.props.cookieBar = components.makeEmptyConfig({component: 'zoezi-cookie-bar'});
        }
        
        if (!config.root.props.domainname && config.domainname) {
            config.root.props.domainname = config.domainname;
        }
        
        setRootProps(config);
    }
    
    components.registerVueComponents(homepage.components, config, homepage_type);
    Vue.filter('price', formatPrice)
    Vue.mixin(setProp);
    
    // Apply global style from components before they are created
    Vue.mixin({
        beforeCreate() {
            const componentName = this.$options.name;
            if (componentName?.startsWith('zoezi-')) {
                const component = components.getComponent(componentName);
                if (component?.css) {
                    addOrUpdateStyle(`zoezi-style-${componentName}`, component.css);
                }
            }
        }
    });
    
    let router = initRouter(config, location.pathname.startsWith('/homepage/') ? homepage.basepath : '/', homepage_type);
    let store = initStore();
    
    let vuetify = getVuetify(config);
    
    if (MB) {
        if (!config.root.props.colors) {
            config.root.props.colors = Object.assign({}, vuetify.framework.theme.defaults.light);
        }
    }
    
    window.$components = components;
    
    let vue = new Vue({
        vuetify,
        router,
        store,
        render: h => h(App),
        data: () => ({
            edit: edit,
            homepage_id: homepage.id,
            compact: homepage.compact,
            shared: homepage.shared,
            siteconfig: config,
            current_revision_id: homepage.current_revision_id,
            published_revision_id: homepage.published_revision_id,
            sites: homepages || [],
            sitesLoaded: homepages && homepages.length,
            mobilePreview: false,
            mobilePreviewLoading: false,
            revisionPreview: null,
            basepath: homepage.basepath,
            homepage_type: homepage.type || 'mb',
            isBuilding: false,//homepage.status == 'pending',
            
            showEditPanel: !isInIframe(),
            
            mobilePreviewIframe: isInIframe(),
            
            components: components
        }),
        watch: {
            '$store.state.saving'(saving) {
                if (!saving && this.$store.state.needToSave) {
                    this.saveHomePage();
                }
            },
            
            // FIXME: Move someplace else
            'siteconfig.css': {
                immediate: true,
                handler(css) {
                    this.loadCss(css);
                }
            },
            'siteconfig.fonts': {
                immediate: true,
                deep: true,
                handler(fonts) {
                    if (!fonts) {
                        return;
                    }
                    
                    let style = '';
                    let families = [];
                    
                    let getOneStyle = function(match, mq, o) {
                        if (!o) {
                            return '';
                        }
                        if (families.indexOf(o.font) == -1) {
                            families.push(o.font);
                        }
                        let mqPrefix = mq ? mq + '{' : '';
                        let mqSuffix = mq ? '}' : '';
                        
                        let res = `${mqPrefix}${match}{`;
                        if (o.size) {
                            res += `font-size:${o.size};`
                        }
                        if (o.font) {
                            res += `font-family:"${o.font}";`;
                        }
                        if (o.letterspacing) {
                            res += `letter-spacing:${o.letterspacing};`;
                        }
                        if (o.italic) {
                            res += 'font-style:italic;';
                        }
                        if (o.color) {
                            res += `color:${o.color};`;
                        }
                        if (o.lineheight) {
                            res += `line-height:${o.lineheight};`;
                        }
                        if (o.uppercase) {
                            res += `text-transform:uppercase;`;
                        }
                        res += `}${mqSuffix}`;
                        return res;
                    }
                    
                    let getStyle = function(match, o) {
                        if (o.mobile || o.desktop) {
                            return getOneStyle(match, null, o.desktop) + getOneStyle(match, '@media screen and (max-width: 960px)', o.mobile);
                        }
                        
                        return getOneStyle(match, o);
                    }
                    
                    for (let i=1; i <= 6; ++i) {
                        let h = fonts['h' + i];
                        if (h) {
                            style += getStyle('.v-main__wrap h' + i, h);
                        }
                    }
                    if (fonts['p']) {
                        style += getStyle('.v-main__wrap p', fonts['p'])
                    }
                    if (fonts['menu']) {
                        style += getStyle('.zoezi-menuitem .v-btn__content', fonts['menu'])
                    }
                    this.loadTextStyleCss(style);
                    
                    families.forEach(family => {
                        this.loadFont(family, family);
                    })
                }
            },
            'siteconfig.root.props': {
                immediate: false,
                deep: true,
                handler() {
                    setRootProps(this.siteconfig);
                }
            },
            $route(to) {
                if (isInIframe()) {
                    window.top.postMessage({action: 'setRoute', data: to.path});
                }
            }
        },
        methods: {
            colorToHex(color) {
                if (!color) {
                    return null;
                }
                if (color.startsWith('#')) {
                    return color;
                }
                return classToHex(camelize(color), colors, this.$vuetify.theme.currentTheme);
            },
            h2r(hex, opacity) {
                let c;
                if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){
                    c = hex.substring(1).split('');
                    if(c.length== 3){
                        c= [c[0], c[0], c[1], c[1], c[2], c[2]];
                    }
                    c= '0x'+c.join('');
                    if(opacity>1) opacity = 1;
                    if(opacity<0) opacity = 0;
                    return 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+','+opacity+')';
                }
                return 'rgba(0,0,0,1)';
            },
            prepareConfigForSave(config) {
                config = JSON.parse(JSON.stringify(config));
                if (config.appComponent) {
                    delete config.appComponent;
                }
                return config;
            },
            showSaveError(response) {
                let showError = (text) => {
                    this.$store.commit('showErrorDialog', {
                        title: 'Det gick inte att spara',
                        text,
                        actionText: 'Ladda om sidan',
                        action: () => location.reload()
                    })
                };

                response.json().then(response_data => {
                    let text = response_data && response_data.message ? this.$translate(response_data.message) : null;
                    if (!text || response_data.message == 'Homepage has been altered') {
                        text = 'Det blev fel när dina ändringar skulle sparas. Det här kan inträffa om någon annan ändrat på sidan samtidigt.'
                    }
                    showError(text);
                });
            },
            saveHomePage(reload) { // FIXME: Move to EditPanel?
                this.$store.commit('setNeedToSave', this.$store.state.saving);
                if (this.$store.state.saving || !this.$store.state.isLoggedIn) {
                    return;
                }
                
                console.log('Saving homepage');
                this.$store.commit('setSaving', true);
                let data = {id: this.homepage_id, basepath: this.basepath, config: this.prepareConfigForSave(this.siteconfig), current_revision_id: this.current_revision_id, publish: this.siteconfig.autoPublish, compact: this.compact};
                this.$api.post('/api/homepage/change', data).then(response => {
                    if (response.ok) {
                        return response.json().then(response_data => {
                            this.current_revision_id = response_data.current_revision_id;
                            if (data.publish) {
                                this.published_revision_id = this.current_revision_id;
                            }
                            if (reload) {
                                location.reload();
                            }
                        })
                    } else {
                        this.showSaveError(response);
                    }
                }).finally(() => {
                    this.$store.commit('setSaving', false);
                });
            },
            switchHomepage(id) {
                this.$api.get('/api/homepage/get', {id}).then(hp => {
                    if(hp.basepath) {
                        location.pathname = hp.basepath;
                    }
                });
            },
            addEmptyHomepage(name, basepath, shared, type='mb') {
                let data = {name, basepath, shared, type};
                this.$api.post('/api/homepage/add/empty', data).then(response => response.json().then(data => {
                    this.switchHomepage(data.id);
                }));
            },
            addCopyOfThisHomepage(name, basepath, shared) {
                let data = {id: this.$root.homepage_id, name, basepath, shared};
                this.$api.post('/api/homepage/add/copy', data).then(response => response.json().then(data => {
                    this.switchHomepage(data.id);
                }));
            },
            addHomePageWithConfig(name, config, basepath, shared, type='mb') {
                let data = {name, config, basepath, shared, type};
                this.$api.post('/api/homepage/add/withconfig', data).then(response => response.json().then(data => {
                    this.switchHomepage(data.id);
                }));
            },
            revertToRevision(id) {
                this.$api.get('/api/homepage/revision/get', {homepage_id: this.$root.homepage_id, id: id}).then(data => {
                    this.$root.siteconfig = data.config;
                    this.$root.saveHomePage(true);
                })
            },
            publish() {
                let data = {id: this.homepage_id, revision_id: this.current_revision_id}
                this.$api.post('/api/homepage/publish', data).then(response => {
                    if (response.ok) {
                        this.published_revision_id = this.current_revision_id;
                    } else {
                        this.showSaveError(response);
                    }
                });
            },
            getEditCardClasses() {
                return ['headline', 'zoezi-edit-color'];
            },
            loadFont(font, suffix='', onload=null) {
                if (!font || font == 'Roboto' || font == 'Arial') {
                    return;
                }
                let FONTID = `zoezi-global-font${suffix}`;
                let fontElement = document.getElementById(FONTID);
                if (!fontElement) {
                    fontElement = document.createElement("link");
                    fontElement.setAttribute("rel", "stylesheet")
                    fontElement.setAttribute("type", "text/css")
                    fontElement.setAttribute('id', FONTID);
                    document.head.appendChild(fontElement);
                    if (onload) {
                        fontElement.onload = onload;
                    }
                }
                
                let href = `https://fonts.googleapis.com/css?family=${encodeURIComponent(font)}:400,300,300italic,400italic,600,600italic,700,700italic,800,800italic`;
                fontElement.setAttribute("href", href)
            },
            loadCss(style) {
                addOrUpdateStyle('zoezi-global-style', style)
            },
            loadTextStyleCss(style) {
                addOrUpdateStyle('zoezi-text-style', style);
            },
            setThemeColors(colors) {
                if (!colors)  {
                    return;
                }
                for (const [key, value] of Object.entries(colors)) {
                    document.documentElement.style.setProperty('--z-' + key, value);
                }
                Object.assign(this.$vuetify.theme.themes.light, {anchor: this.$vuetify.theme.themes.light.anchor, ...colors});
            },
            setEditMode() {
                let wasInEditMode = getCookie('editmode') == '1';
                setCookie('editmode', '1');
                if(!window.__editModeAvailable || (homepage.shared && !homepage.pure)) {
                    this.$store.commit('setEditModeInitializing', true);
                    setTimeout(() => { location.reload(); }, 10);
                    return;
                }
                // If there are unpublished changes and we weren't already in edit mode,
                // reload so the backend serves the current revision config
                if (!wasInEditMode && (!this.published_revision_id || this.current_revision_id != this.published_revision_id)) {
                    this.$store.commit('setEditModeInitializing', true);
                    setTimeout(() => { location.reload(); }, 10);
                    return;
                }
                this.edit = true;
                if (this.isBuilding) {
                    this.checkIfBuilt();
                }
            },
            reloadHomepageInEditMode(revision_id) {
                getHomePageConfig(this.homepage_id, revision_id).then(data => {
                    initVue(this.sites, data, true);
                });
            },
            loadSites() {
                this.sitesLoaded = true;
                return fetch(`${HOSTNAME}/api/homepage/get/all`).then(response => response.json().then(homepages => {
                    this.sites = homepages || [];
                }))
            },
            followLink(link, id) {
                if (this.$root.edit && id) {
                    return;
                }
                let anchor;
                if (typeof link === 'object') {
                    if (link.newTab && link.href) {
                        window.open(link.href, '_blank')?.focus();
                        return;
                    } else if (link.href) {
                        window.location.href = link.href;
                        return;
                    } else {
                        anchor = link.anchor;
                        link = link.page;
                    }
                }

                if (this.$route.path != link || anchor) {
                    if(id) {
                        link = link + '/' + id;
                    }
                    this.$router.push({path: link, hash: anchor}, () => {}, () => {});
                }
            },
            checkIfBuilt() {
                getHomePageConfig(this.homepage_id, this.published_revision_id).then(data => {
                    if (data.status == 'pending' && !IS_LOCALHOST) {
                        if (this.edit) {
                            setTimeout(this.checkIfBuilt, 1000);
                        }
                    } else {
                        this.isBuilding = false;
                    }
                })
            },
            getDefaultPage(page) {
                let value = this.siteconfig?.pages[page];
                let def = '/' + page;
                return value || def;
            },
            setTitle(route) {
                route = route || this.$route;
                if (!route) {
                    return;
                }
                let prefix = route.name == '/' ? '' : route.name + ' - ';
                document.title = `${prefix}${this.siteconfig?.root?.props?.title || ''}`;
            },
            setMetaDescription(route) {
                route = route || this.$route;
                let description = route.meta.description || '';
                document.getElementById('metadescription')?.setAttribute('content', description)
            }
        },
        created() {
            this.loadFont(this.siteconfig?.root?.props?.font);
            this.$api.setVueRoot(this);
            this.$translations.setVueRoot(this);
            this.$booking.setVueRoot(this);
            this.$store.dispatch('setVueRoot', this);
            this.$store.dispatch('checkIfLoggedIn');
            if (getUrlParameterThis('applesignin') == 'success') { // Only do this when user been redirected from apple-auth.zoezi.se
                this.$store.dispatch('signinWithApple');
            }
            this.setThemeColors(this.siteconfig?.root?.props?.colors);
            this.setTitle();
            this.setMetaDescription();

            // Subscribe to product updates
            this.productsUnsubscribe = this.$api.subscribe({
                type: 'trainingcardtype',
                callback: () => this.$store.dispatch('refreshProducts')
            });
        },
        mounted() {
            let accountrequest = getUrlParameterThis('accountrequest')
            if (accountrequest && this.$route.path != this.siteconfig.pages.mypages) {
                this.$router.push({ path: this.siteconfig.pages.mypages, query: { accountrequest }})
            }
            document.addEventListener('keydown', e => {
                if ((e.ctrlKey || e.metaKey) && e.key === 'm') {
                    // Switch to staff page
                    if (this.$store.state.user?.isAdmin) {
                        window.location = '/staff';
                    }
                }
            });
        },
        beforeDestroy() {
            if (this.productsUnsubscribe) {
                this.productsUnsubscribe();
            }
        }
    }).$mount('#app')
    
    window.$vuetify = vue.$vuetify;
    window.$vue = vue;
}

function getHomePageConfig(id, revision_id='') {
    if (!revision_id) {
        revision_id = getUrlParameterThis('revision_id') || '';
    }
    
    return fetch(`${HOSTNAME}/api/homepage/get?id=${id}&revision_id=${revision_id}`).then(response => response.json().then(data => {
        return data;
    }))
}

function loadScript(url) {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = url;
        script.onload = () => resolve();
        script.onerror = () => reject(new Error(`Script load error for ${url}`));
        document.head.appendChild(script);
    });
}

function loadAcornAndWalk() {
    // First, load Acorn
    return loadScript('https://cdn.jsdelivr.net/npm/acorn').then(() => {
        // After Acorn is loaded and ready, load Acorn-walk
        return loadScript('https://cdn.jsdelivr.net/npm/acorn-walk/dist/walk.js');
    }).catch(error => {
        console.error('Failed to load acorn and acorn-walk scripts. Developer portal components with composition API will not work:', error);
        throw error;
    });
}

const $loadActivePage = () => {
    let revision_id = getUrlParameterThis('revision_id');
    if(revision_id) {
        return fetch(`${HOSTNAME}/api/homepage/get?revision_id=${revision_id}`).then(response => response.json().then(data => {
            initVue(null, data);
        }));
    }
    
    let edit = getCookie('editmode') == '1' && window.__editModeAvailable && !getUrlParameterThis('noeditmode');
    let homepage = window.HOMEPAGE_CONFIG || {};
    
    
    const init = (homepage) => {
        const homepage_type = homepage.type || 'mb';
        if (homepage_type == 'sf') {
            loadAcornAndWalk().then(() => {
                initVue(null, homepage);
                if(edit) window.$vue.setEditMode();
            });
        } else {
            initVue(null, homepage);
            if(edit) window.$vue.setEditMode();
        }
    }
    
    if(edit && homepage.shared) {
        fetch(`${HOSTNAME}/api/homepage/get?id=${homepage.id}&path=${location.pathname}&pure=true`).then(response => response.json().then(hp => {
            hp.pure = true;
            init(hp);
        }));
    } else init(homepage);
}

$loadActivePage();
